import React, { useEffect, useState } from 'react';

import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { Fragment } from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import SweetAlert from 'react-bootstrap-sweetalert';

import { useParams } from 'react-router-dom';

import GrupoIncentivoDetail from 'components/Tvendo/Sale/QuotaBPartner/CuotasIncentivos/Unilever/GrupoIncentivo/GrupoIncentivoDetails/List';
import GrupoIncentivoCanal from 'components/Tvendo/Sale/QuotaBPartner/CuotasIncentivos/Unilever/GrupoIncentivo/GrupoIncentivoCanal/List';
import { Toasty, useToasty } from 'hooks/Toasty';
import { wsRemove } from 'services/WService';

//Tabs
import { TabPanel, indexTab, useStyleTabs } from 'hooks/TabPanel';
import { wsGet } from 'services/WService';
import { wsFindBy } from 'services/WService';

const useStyles = makeStyles(styles);

export default function () {
  const claseStyleTab = useStyleTabs();
  const classes = useStyles();

  const { id } = useParams();
  const [value, setValue] = useState(0);
  const [notify, showNotify] = useToasty();

  const themeTab = useTheme();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const [alert, setAlert] = useState(null);
  const hideAlert = () => {
    setAlert(null);
  };
  function confirm(entity, id, reload) {
    setAlert(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title="Esta seguro de eliminar!"
        onConfirm={() => {
          remove(entity, id, reload);
          hideAlert();
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      />
    );
  }

  async function remove(entity, id, reload) {
    let response = await wsRemove(entity, id);
    if (response.success) {
      showNotify(response.message);
      reload();
    } else {
      showNotify(response.message, 'error');
    }
  }

  //#region Listados de api
  const [grupoIncentivo, setGrupoIncentivo] = useState({});
  const [giDetails, setGIDetails] = useState([]);
  const [giCanals, setGICanals] = useState([]);

  async function getGrupoIncentivo() {
    let response = await wsGet('sale/grupo-incentivo', id);
    if (response.success) {
      setGrupoIncentivo(response.data);
      // setGIDetails(response.data.details);
      // setGICanals(response.data.canals);
    }
  }
  async function getGrupoIncentivoDetail() {
    let response = await wsFindBy('sale/grupo-incentivo-detalle', { unilever_grupo_id: grupoIncentivo.id });
    if (response.success) setGIDetails(response.data);
  }
  async function getGrupoIncentivoCanal() {
    let response = await wsFindBy('sale/grupo-incentivo-canal', { unilever_grupo_id: grupoIncentivo.id });
    if (response.success) setGICanals(response.data);
  }

  useEffect(() => {
    getGrupoIncentivo();
  }, []);

  useEffect(()=> {
    if(grupoIncentivo.id){
      getGrupoIncentivoDetail();
      getGrupoIncentivoCanal();
    }
  },[grupoIncentivo.id]);

  return (
    <Fragment>
      <Toasty action={notify} />
      {alert}
      {id != 0 ? (
        <Fragment>
          <h4 style={{ fontWeight: 'bold' }}>Grupo Incentivo: {grupoIncentivo.description}</h4>
          <div className={claseStyleTab.root}>
            <AppBar position="static" color="default">
              <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                textColor="secondary"
                aria-label="Tabs"
                indicatorColor="secondary"
              >
                <Tab label="Detalle" {...indexTab(0)} />
                <Tab label="Distribución" {...indexTab(1)} />
              </Tabs>
            </AppBar>
            <SwipeableViews
              axis={themeTab.direction === 'rtl' ? 'x-reverse' : 'x'}
              index={value}
              onChangeIndex={handleChangeIndex}
            >
              <TabPanel value={value} index={0} dir={themeTab.direction}>
                <GrupoIncentivoDetail
                  id={id}
                  showNotify={showNotify}
                  confirm={confirm}
                  giDetails={giDetails}
                  grupoIncentivo={grupoIncentivo}
                  reload={getGrupoIncentivoDetail}
                />
              </TabPanel>
              <TabPanel value={value} index={1} dir={themeTab.direction}>
                <GrupoIncentivoCanal
                  id={id}
                  showNotify={showNotify}
                  confirm={confirm}
                  giCanals={giCanals}
                  setGICanals={setGICanals}
                  grupoIncentivo={grupoIncentivo}
                  reload={getGrupoIncentivoCanal}
                />
              </TabPanel>
            </SwipeableViews>
          </div>
        </Fragment>
      ) : undefined}
    </Fragment>
  );
}
